import * as React from 'react';
import { useState } from 'react';
import SearchForm from '../../components/Search/SearchForm/SearchForm';
var Search = function () {
    var _a = useState(false), isEdit = _a[0], setIsEdit = _a[1];
    return (React.createElement("div", { className: "container-fluid" },
        React.createElement("div", { className: "animated fadeIn" },
            React.createElement("h1", { className: "display-3" }, "\u041D\u043E\u0432\u043E \u0422\u044A\u0440\u0441\u0435\u043D\u0435"),
            React.createElement("hr", null),
            React.createElement("div", { className: "row" },
                React.createElement("div", { className: "col-md-5" },
                    React.createElement(SearchForm
                    // @ts-ignore
                    , { 
                        // @ts-ignore
                        isEdit: setIsEdit }))))));
};
export default Search;



//////////////////
// WEBPACK FOOTER
// ./src/views/Searches/Search.tsx
// module id = 453
// module chunks = 0